module.exports = __webpack_public_path__ + "img/addequip.32c0ee77.jpg";